<div class="container">
  <h2>¡Gracias por compartir tus datos con VEMO!</h2>
  <h3>Te mantendremos al tanto de cualquier novedad.</h3>
  <mat-icon>check_circle_outline</mat-icon>
</div>
